// Basic room player collection selector.

import { useMemo } from 'react';
import { useRoomStateSelector } from './useRoomStateSelector';
import { RoomPlayer } from '@airhead-games/shared/types';

interface UseRoomPlayersReturn {
  players: RoomPlayer[];
  playerCount: number;
}

export function useRoomPlayers(): UseRoomPlayersReturn {
  const players = useRoomStateSelector((state) =>
    state?.players ? Object.values(state.players) : []
  );
  const playerCount = useMemo(() => players.length, [players]);

  return {
    players,
    playerCount,
  };
}
